import { Button, ForwardedButton, Row, Td, Tr } from 'hatch-components';
import ConfirmMenu from 'root/components/molecules/ConfirmMenu';
import styled from 'styled-components';

export const StyledButton = styled(Button)(
  ({
    theme: {
      font,
      colors,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    fontSize: font.size.sm,
    height: 48,
    [mobile]: {
      '&:hover, &:active, &:focus': {
        background: colors.primaryTint,
        color: colors.white,
      },
      alignItems: 'center',
      background: colors.primary,
      borderRadius: '100%',
      color: colors.white,
      display: 'flex',
      fontSize: font.size.sm,
      height: spacing.md,
      justifyContent: 'center',
      lineHeight: 1,
      minHeight: 0,
      minWidth: 0,
      padding: spacing.xxxs,
      span: {
        display: 'none',
      },
      width: spacing.md,
    },
  }),
);

export const StyledTr = styled(Tr)(({ archived }) => ({
  td: {
    opacity: archived ? 0.5 : 1,
  },
  'td:last-child': {
    opacity: 1,
  },
}));

export const StyledMobilePrefix = styled(Row)(
  ({
    label,
    isLoader,
    theme: {
      spacing,
      responsive: { mobile },
    },
  }) => ({
    [mobile]: {
      '&:before': {
        content: `"${label}"`,
        display: isLoader && 'none',
        paddingRight: spacing.xxs,
      },
      alignItems: 'center',
    },
  }),
);

export const StyledName = styled.p(
  ({
    theme: {
      colors,
      font,
      responsive: { mobile },
    },
  }) => ({
    display: 'block',
    fontSize: font.size.sm,
    fontWeight: font.weight.extraBold,
    lineHeight: font.lineHeight.sm,
    [mobile]: {
      color: colors.black,
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  }),
);

export const StyledArchived = styled.span(({ theme: { font, spacing } }) => ({
  fontSize: font.size.sm,
  fontWeight: font.weight.normal,
  lineHeight: font.lineHeight.sm,
  paddingRight: spacing.xxs,
}));

export const StyledId = styled.small(
  ({
    isLoader,
    theme: {
      colors,
      font,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    color: colors.darkGrey,
    display: 'block',
    fontSize: font.size.xs,
    fontWeight: font.weight.normal,
    lineHeight: font.lineHeight.xs,
    [mobile]: {
      '&:before': {
        content: '"Workspace "',
        display: isLoader && 'none',
      },
      fontSize: font.size.sm,
      paddingTop: spacing.sm,
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  }),
);

export const StyledEditTd = styled(Td)(
  ({
    theme: {
      spacing,
      responsive: { mobile },
    },
  }) => ({
    [mobile]: {
      height: 38,
      position: 'absolute',
      right: spacing.md,
      top: 0,
      width: 24,
    },
  }),
);

export const StyledNameTd = styled(Td)(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    [mobile]: {
      width: `calc(100% - 24px - 24px)`,
    },
  }),
);

export const StyledEditButton = styled(ForwardedButton)(
  ({ theme: { colors } }) => ({
    '&:hover': {
      circle: {
        fill: colors.darkGrey,
      },
    },
    height: 38,
    margin: 0,
    padding: 0,
    svg: {
      margin: 0,
    },
  }),
);

export const StyledConfirmMenu = styled(ConfirmMenu)(
  ({ theme: { colors, font } }) => ({
    '.desktopConfirmActionButton': {
      '&:hover': {
        background: colors.primaryTint,
      },
      background: colors.primary,
    },
    strong: {
      fontWeight: font.weight.bold,
    },
  }),
);
